/** @graphql cc **/
import gql from 'graphql-tag';

import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient.ts';

import {
	type fetchPresenceConfluenceUsersQuery as UsersQuery$data,
	type fetchPresenceConfluenceUsersQueryVariables as UsersQuery$variables,
} from './__types__/FetchPresenceConfluenceUsersQuery.ts';

export const fetchPresenceConfluenceUsers = (accountIds: string[]) => {
	// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
	return getApolloClient()
		.query<UsersQuery$data, UsersQuery$variables>({
			query: gql`
				query fetchPresenceConfluenceUsersQuery($accountIds: [String]) {
					confluenceUsers(accountIds: $accountIds) {
						nodes {
							profilePicture {
								isDefault
								path(type: RELATIVE)
							}
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
							displayName
						}
					}
				}
			`,
			variables: {
				accountIds,
			},
		})
		.then(({ data }) => {
			return (
				data?.confluenceUsers?.nodes
					?.filter((user) => (user as any)?.accountId)
					.map((user) => ({
						avatar: user?.profilePicture?.path ?? '',
						email: '',
						isGuest: undefined,
						name: user?.displayName ?? '',
						userId: (user as any)?.accountId ?? '',
					})) ?? []
			);
		});
};
